<template>
	<section>
        <el-col :span="24" class="title-bar">
		    我的最愛主題		
		</el-col>
        <el-col :span="24" class="page-bar">
			<div class="total-results"> {{ totalResult }} </div>
			<el-pagination v-if="favoriteList.length > 0" layout="prev, pager, next" prev-text="prev" next-text="next"
                :current-page="this.$store.state.favorite.listStatus.currentPage"
                @current-change="list_current_change"
                :page-size="this.$store.state.favorite.listStatus.pageSize" 
                :total="this.$store.state.favorite.listStatus.total" style="float:right;">
			</el-pagination>
		</el-col>
        <!--列表-->
        <el-table   :data="favoriteList" 
                v-loading="listLoading" 
                empty-text="暫無數據"
                @sort-change="sortChange"
                @row-click="rowClick" 
                style="min-width: 100%;">
			<el-table-column min-width="33%" prop="title" label="主題" class="title-column" sortable="custom">
                <template slot-scope="scope">	
					{{ scope.row.title  }} 
					<div class="tableCompulsory" v-if="scope.row.course_type === 1">必修</div>
              		<div class="tableElective" v-if="scope.row.course_type === 0">選修</div>
				</template>
			</el-table-column>
			<el-table-column min-width="23%" prop="department" label="部門" sortable="custom">
			</el-table-column>
			<el-table-column min-width="13%" prop="category" label="分類" sortable="custom">
			</el-table-column>
			<el-table-column min-width="13%" prop="level" label="程度" :formatter="formatLevel" sortable="custom">
			</el-table-column>
			<el-table-column min-width="13%" prop="type" label="類型" :formatter="formatType">
			</el-table-column>
			<el-table-column min-width="19%" prop="rating" label="評分" sortable="custom">
				<template slot-scope="scope">	
					<StarRating v-if="favoriteList[scope.$index].rating > 0" :rating="favoriteList[scope.$index].rating" text-class="star-rating" :max-rating="5" :star-size="16" :read-only="true" :increment="0.1"></StarRating>
					<StarRating v-else :rating="favoriteList[scope.$index].rating" :show-rating="false" text-class="star-rating" :max-rating="5" :star-size="16" :read-only="true" :increment="0.1"></StarRating>
				</template>
			</el-table-column>
			<el-table-column min-width="16%" prop="mtime" label="更新時間" :formatter="formatMtime" sortable="custom">
			</el-table-column>
		</el-table>
    </section>
</template>

<script>
import util from '@/common/js/util';
import API from '../../api/api';
export default {
    name: 'Favorite',
    data() {
        return {
            listLoading: false,
            totalResult:'',
            favoriteList: [],
        }
    },
    watch: {
        '$store.state.userInfoReady': {
            immediate: true,
            handler(val) {
                if (val) {
                    this.initial();
                }
            }
        }
    },
    created() {
        this.$store.state.nowStatus = 16;
    },
    methods: {
        async initial() {
            this.reloadFavoriteList();
        },
        reloadFavoriteList() {
            this.listLoading = true;
            this.favoriteList.splice(0);

            API.getFavorites({
					offset: this.$store.state.favorite.listStatus.offset,
                    by: this.$store.state.favorite.listStatus.by,
					order: this.$store.state.favorite.listStatus.order,
                    keyword: '',
				}).then((response) => {
                if(response.status) {
                    redirectLogin(response.data);
                    this.listLoading = false;
                    if(!JSON.parse(response.request.response).error_msg) {
                        this.message.error('取得我的最愛發生錯誤!');
                    } else {
                        this.message.error(JSON.parse(response.requt.response).error_msg);	
                    }
                } else {
                    this.listLoading = false;
                    //全部筆數
                    this.$store.state.favorite.listStatus.total = response.total;
                    //確認頁數存在
                    if (response.total != 0 && 
                        this.$store.state.favorite.listStatus.offset >= this.$store.state.favorite.listStatus.total) {
                        this.list_current_change(1);
                        return;
                    }
                    //資源列表顯示結果字串
                    if(this.$store.state.favorite.listStatus.total === 0) {
                        this.totalResult = ' 共 ' + this.$store.state.favorite.listStatus.total + ' 筆結果';
                    } else {
                        this.totalResult = this.$store.state.favorite.listStatus.pageSize * (this.$store.state.favorite.listStatus.currentPage - 1) 
                                                        + 1 + ' - ' + 
                                                        (this.$store.state.favorite.listStatus.pageSize * (this.$store.state.favorite.listStatus.currentPage - 1) 
                                                        + response.result.length) + ' 筆，' + ' 共 ' + this.$store.state.favorite.listStatus.total + ' 筆結果';
                    }
                    
                    for(let i = 0 ; i < response.result.length ; i++) {
                        let resourceObj = {};
                        resourceObj.id = response.result[i].id;
                        resourceObj.code = response.result[i].code;
                        resourceObj.title = response.result[i].title;
                        resourceObj.course_type = response.result[i].course_type;
                        resourceObj.department = response.result[i].actual_dep ? 
                        response.result[i].actual_dep.name : "";
                        resourceObj.category = response.result[i].category.title;
                        resourceObj.level = response.result[i].level;
                        resourceObj.type = response.result[i].fileAttrs;
                        resourceObj.secret = response.result[i].secret;
                        resourceObj.mtime = response.result[i].mtime;
                        resourceObj.author = response.result[i].author;
                        if(response.result[i].rating) {
                            resourceObj.rating = Math.ceil(response.result[i].rating.average*10)/10;
                        } else {
                            resourceObj.rating = 0;	
                        }
                        resourceObj.fileAttrs = response.result[i].fileAttrs; 
                        this.favoriteList.push(resourceObj);
                    }
                }
            });
        },
        list_current_change(val) {
            this.$store.state.favorite.listStatus.currentPage = val;
            let offset = this.$store.state.favorite.listStatus.pageSize * (this.$store.state.favorite.listStatus.currentPage - 1);
            this.$store.state.favorite.listStatus.offset = offset;
            this.reloadFavoriteList();
        },
        formatType(row, column) { 
            return util.resourceInfo.formatType(row.type);
        },
        formatLevel: function (row, column) {
            return 'L ' + row.level;
        },
        formatMtime: function (row, column) {	
            if(row.mtime === null || row.mtime === 0 || row.mtime === undefined) {
                return '-';
            }

            return util.formatDate.format(new Date(row.mtime), 'yyyy-MM-dd');
        },
        sortChange: function(column, prop, order) {	
            if(column.order === 'descending') {
                this.$store.state.favorite.listStatus.order = 'desc';	
            } else if(column.order  === 'ascending') {
                this.$store.state.favorite.listStatus.order = 'asc';	
            } else {
                this.$store.state.favorite.listStatus.order = null;		
            }
            this.$store.state.favorite.listStatus.by = column.prop;

            //取得資源列表
            this.reloadFavoriteList();
        },
        rowClick: function(row, event) {
            this.$store.state.barBreadcrumbs = [];
            this.$store.state.entrance = "favorite";
            this.$router.push({ path: '/info/' +  row.id});
        },
    },
}
</script>

<style lang="scss" scoped>
.title-bar {
    background-color: #F5F8FA;
    color: #3C3B38;
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 24px;
    padding-top: 20px;
    padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// Favorite.vue?32ff3c3c